var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 322.28 280.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:19px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 322.28,
    height: 280.62
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u0420\u0435\u0441\u0443\u0440\u0441 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.45,176.31,198,115.61l-79.49,77.57a16,16,0,0,0-4.69,11.31v50.61c0,14.34,17.32,21.29,27.31,11.31l33.58-33.58,73.17,36.59A16,16,0,0,0,270.77,258L312.52,28.4a16,16,0,0,0-21.59-17.77L19.65,116.8a16,16,0,0,0-2.77,28.4l62.59,29.93A16,16,0,0,0,94.45,176.31Z",
    transform: "translate(0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.235716b60d545efbbea47c95e7f73adc.svg";
export { ForwardRef as ReactComponent };